import styled from 'styled-components'
import SelectionCheckbox from '../listView/SelectionCheckbox.jsx'

const ItemRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  cursor: pointer;
  border-radius: 0.375rem;
  color: ${({ theme }) => theme.font.color};

  &:hover {
    background: ${({ theme }) => theme.dropdown.selectedBackground};
    color: ${({ theme }) => theme.dropdown.selectedFont};
  }
`

const ItemText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`

const Line = styled.div`
  font-size: var(--font-XS);
  line-height: 1.1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const Secondary = styled(Line)`
  opacity: 0.8;
  font-size: var(--font-XXS);
`

const Indent = styled.div`
  width: ${({ $depth }) => Math.max($depth * 16, 0)}px;
  flex: 0 0 ${({ $depth }) => Math.max($depth * 16, 0)}px;
`

/**
 * GroupFilterMenuItem
 * Props:
 * - item: object from endpoint
 * - selected: boolean
 * - depth: number (0 for flat)
 * - showSecondary: boolean (whether to show description/secondary)
 * - displayField: string (field name to show as main label if present)
 * - onToggle: (valueId) => void
 *
 * Always shows id to users, optional secondary (e.g., description).
 */
const GroupFilterMenuItem = ({
  item,
  selected,
  depth = 0,
  showSecondary = true,
  displayField = 'id',
  descriptionField = 'description',
  onToggle,
}) => {
  const id = item?.id ?? ''
  const primary = (item?.[displayField] ?? item?.id ?? '').toString()
  const secondary = (item?.[descriptionField] ?? '').toString()

  const handleToggle = (e) => {
    // Support being called from both row click (with event) and checkbox onChange (no event)
    if (e && e.preventDefault) {
      e.preventDefault()
      e.stopPropagation()
    }
    if (onToggle) onToggle(id, item)
  }

  return (
    <ItemRow onClick={handleToggle} role="menuitem" aria-checked={selected}>
      <Indent $depth={depth} />
      <SelectionCheckbox state={selected ? 'selected' : 'none'} onChange={handleToggle} />
      <ItemText title={secondary ? `${primary} — ${secondary}` : primary}>
        <Line>{primary}</Line>
        {showSecondary && !!secondary && <Secondary>{secondary}</Secondary>}
      </ItemText>
    </ItemRow>
  )
}

export default GroupFilterMenuItem
